import { CatalogueActions } from "../actions";
// import { EntityState, EntityAdapter, createEntityAdapter } from "@ngrx/entity";
import { Category } from "../../../routes/catalog/models/category.model";

export interface State {
  entities: Category[];
  errors: {
    data: any[] | any;
    message: string[];
  } | null;
  pending: boolean;
}

// export const adapter: EntityAdapter<Category> = createEntityAdapter<Category>();

export const initialState: State = {
  entities: [],
  errors: null,
  pending: false,
};

export function reducer(
  state = initialState,
  action: CatalogueActions.Union,
): State {
  switch (action.type) {
    case CatalogueActions.TYPES.ListAttempt:
      console.log("CatalogueActions.TYPES.ListAttempt");
      return {
        ...state,
        pending: true,
      };

    case CatalogueActions.TYPES.ListSuccess:
      console.log("CatalogueActions.TYPES.ListSuccess");
      return { ...state, entities: action.payload, pending: false };

    case CatalogueActions.TYPES.ListFailure:
      console.log("CatalogueActions.TYPES.ListFailure");
      return {
        ...state,
        errors: action.payload,
        pending: false,
      };

    default:
      return state;
  }
}
